angular.module('cmsWeb.main', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('cmsWeb.main', {
                url: '',
                views: {
                    'navbars@': {
                        controller: 'NavbarsCtrl as navbarsCtrl',
                        templateUrl: 'modules/navbars.tmpl.html'
                    },

                    'mainView@': {
                        controller: 'LoginCtrl as loginCtrl',
                        templateUrl: 'modules/home.tmpl.html'
                    }
                }
            });
    }])

    .controller('NavbarsCtrl',
        ['CmsAccountModel',
            '$location',
            function (CmsAccountModel,
                      $location) {

        var navbarsCtrl = this;

        navbarsCtrl.availableSearchTypeOptions = [
            { name: 'Auto', value: 'AUTO'},
            { name: 'Email', value: 'EMAIL'},
            { name: 'Full Name', value: 'FULL_NAME'},
            { name: 'Credit Card Number', value: 'CREDIT_CARD_NUMBER'},
            { name: 'BT Transaction Number', value: 'BT_TRANSACTION_NUMBER'},
            { name: 'User ID', value: 'USER_ID'},
            { name: 'SNID', value: 'SNID'}
        ]


        navbarsCtrl.searchText = null;
        navbarsCtrl.selectedSearchType = 'AUTO';
        navbarsCtrl.leftBarClosed = true;


        navbarsCtrl.searchFormSubmit = function () {

            if (!navbarsCtrl.searchText) {
                return;
            }
            $location.path('search/' + navbarsCtrl.selectedSearchType.toLowerCase() + '/' + navbarsCtrl.searchText);
        };

        navbarsCtrl.isProduction = function () {
            return isProduction();
        };

        navbarsCtrl.hasAccess = function (minimumRole) {
            return CmsAccountModel.hasAccess(minimumRole);
        }
    }])

    .
    controller('LoginCtrl', [
        '$rootScope',
        '$location',
        function ($rootScope, $location) {

            var loginCtrl = this;

        }]);

